





import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core'
import { IStatutNotificationState, statutNotificationFacadeBase } from './statut-notification.state';
import { StatutNotification } from './statut-notification.model';
import { StatutNotificationService } from './statut-notification.service';
import { StatutNotificationEnum } from '../statut.enum';




@Injectable()
export class StatutNotificationFacade extends statutNotificationFacadeBase  {


 	constructor(_store: Store<IStatutNotificationState>, private _statutNotificationService: StatutNotificationService) {
        super( StatutNotification, _store);
    }

    /* markAllAsRead(notifications: StatutNotification[]): string {

        if (notifications) {
            for (let not of notifications) {
                not.statut = StatutNotificationEnum.Viewed;
                return this.update(not);

            }
        }


    }

    clearAll(notifications: StatutNotification[]): string {

        if (notifications) {
            for (let not of notifications) {
                not.close = true;
                if(not.statut == StatutNotificationEnum.Viewed){
                    not.statut = StatutNotificationEnum.Closed;
                }
                return this.update(not);

            }
        }


    } */



}
